import hoistNonReactStatic from 'hoist-non-react-statics';
import React, { useContext } from 'react';

const codegenContext = React.createContext({
    presentationMetadata: {},
    lineName: '',
    productCode: '',
});

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export function withMetadataContext(WrappedComponent) {
    function WithCodegenContext(props) {
        const currentContext = useContext(codegenContext);
        return <WrappedComponent {...currentContext} {...props} />;
    }
    hoistNonReactStatic(WithCodegenContext, WrappedComponent);
    WithCodegenContext.displayName = `WithCodegenContext(${getDisplayName(
        WrappedComponent
    )})`;
    return WithCodegenContext;
}

export const CodegenContext = codegenContext;
